import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usPhoneNumberFormatter',
     
})
export class UsPhoneNumberPipe implements PipeTransform {
  transform(value: string): any {
    if (!value) {
      return '';
    }

    return `(${value.substr(0,3)}) ${value.substr(3, 3)}-${value.substr(6)}`
  }
}